/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routineMutationResponseOutputRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineMutationResponseOutputVersionExclusiveMin = 0;
export const routineMutationResponseOutputVersionMax = 9007199254740991;

export const routineMutationResponseOutputEffectiveAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineMutationResponseOutputPendingChangesItemVersionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineMutationResponseOutputPendingChangesItemActivatesAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineMutationResponseOutputPendingChangesItemSavedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineMutationResponseOutputPendingChangesItemEffectiveLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineMutationResponseOutputPendingChangesMax = 2;

export const RoutineMutationResponseOutput = zod.object({
  routineId: zod.uuid().regex(routineMutationResponseOutputRoutineIdRegExp),
  version: zod
    .int()
    .gt(routineMutationResponseOutputVersionExclusiveMin)
    .max(routineMutationResponseOutputVersionMax),
  effectiveAt: zod.iso
    .datetime({ offset: true })
    .regex(routineMutationResponseOutputEffectiveAtRegExp),
  pendingChanges: zod
    .array(
      zod.object({
        kind: zod.enum(['sections', 'rotation']),
        versionId: zod.uuid().regex(routineMutationResponseOutputPendingChangesItemVersionIdRegExp),
        activatesAt: zod.iso
          .datetime({ offset: true })
          .regex(routineMutationResponseOutputPendingChangesItemActivatesAtRegExp),
        savedAt: zod.iso
          .datetime({ offset: true })
          .regex(routineMutationResponseOutputPendingChangesItemSavedAtRegExp),
        effectiveLocalDate: zod.iso
          .date()
          .regex(routineMutationResponseOutputPendingChangesItemEffectiveLocalDateRegExp)
          .optional(),
      }),
    )
    .max(routineMutationResponseOutputPendingChangesMax),
});

export type RoutineMutationResponseOutput = zod.input<typeof RoutineMutationResponseOutput>;
export type RoutineMutationResponseOutputOutput = zod.output<typeof RoutineMutationResponseOutput>;
